import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { CheckboxIcon, CheckIcon, CheckboxEmptyIcon } from '../../../Icons';
import ColumnTypes from '../../types/ColumnTypes';
import OrderTypes from '../../types/OrderTypes';
var CHECKED_REGEX = /^(1|true|checked)$/i;

function isTextChecked(text) {
  return CHECKED_REGEX.test(text);
}

function isFieldChecked(field) {
  return field ? Boolean(field.data.checked) : false;
}

function toggleTodo(database, recordKey, columnKey) {
  var field = database.getField(recordKey, columnKey);
  var checked = !isFieldChecked(field);
  database.mergeFieldData(recordKey, columnKey, {
    checked: checked
  });
}

var TodoField = React.memo(function (_ref) {
  var database = _ref.database,
      recordKey = _ref.recordKey,
      columnKey = _ref.columnKey,
      field = _ref.field;
  var isChecked = isFieldChecked(field);
  var onClick = React.useCallback(function (event) {
    if (database.readOnly) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    toggleTodo(database, recordKey, columnKey);
    database.activate(recordKey, columnKey);
  }, [database, columnKey, recordKey]);
  return React.createElement("div", {
    className: classNames('flexbox-grow flexbox-centered height-full', 'center-text padding-vertical-small padding-horizontal-normal', {
      'shade-30 shade-20-on-hover': !isChecked,
      pointer: !database.readOnly
    }),
    style: {
      color: isChecked ? 'rgb(35, 217, 145)' : null
    }
  }, React.createElement("span", {
    onClick: onClick
  }, isChecked ? React.createElement(CheckIcon, null) : React.createElement(CheckboxEmptyIcon, null)));
});
export default function TodoPlugin() {
  return [{
    onEnter: function onEnter(event, database, next) {
      var _database$getActive = database.getActive(),
          record = _database$getActive.record,
          column = _database$getActive.column;

      if (column.type === ColumnTypes.TODO) {
        toggleTodo(database, record.key, column.key);
        return database.activateRecordAfter();
      }

      return next();
    },
    canSort: function canSort(columnType, database, next) {
      if (columnType !== ColumnTypes.TODO) {
        return next();
      }

      return true;
    },
    getSortOptions: function getSortOptions(columnType, database, next) {
      var _ref2;

      if (columnType !== ColumnTypes.TODO) {
        return next();
      }

      return _ref2 = {}, _defineProperty(_ref2, OrderTypes.ASC, 'True first'), _defineProperty(_ref2, OrderTypes.DESC, 'False first'), _ref2;
    },
    getSortStrategies: function getSortStrategies(columnType, database, next) {
      var _ref3;

      if (columnType !== ColumnTypes.TODO) {
        return next();
      }

      var orderBy = function orderBy(order) {
        return function (recordA, recordB, columnKey) {
          var _database$getFieldDat = database.getFieldData(recordA.key, columnKey),
              _database$getFieldDat2 = _database$getFieldDat.checked,
              checkedA = _database$getFieldDat2 === void 0 ? false : _database$getFieldDat2;

          var _database$getFieldDat3 = database.getFieldData(recordB.key, columnKey),
              _database$getFieldDat4 = _database$getFieldDat3.checked,
              checkedB = _database$getFieldDat4 === void 0 ? false : _database$getFieldDat4;

          var aLowerThanB = checkedA === checkedB ? 0 : checkedA > checkedB ? -1 : 1;
          return aLowerThanB * (order === OrderTypes.ASC ? 1 : -1);
        };
      };

      return _ref3 = {}, _defineProperty(_ref3, OrderTypes.ASC, orderBy(OrderTypes.ASC)), _defineProperty(_ref3, OrderTypes.DESC, orderBy(OrderTypes.DESC)), _ref3;
    },
    renderColumnIcon: function renderColumnIcon(columnType, database, next) {
      if (columnType === ColumnTypes.TODO) {
        return React.createElement(CheckboxIcon, {
          size: 12
        });
      }

      return next();
    },
    renderColumnType: function renderColumnType(columnType, database, next) {
      if (columnType === ColumnTypes.TODO) {
        return 'Todos';
      }

      return next();
    },
    renderField: function renderField(_ref4, database, next) {
      var field = _ref4.field,
          record = _ref4.record,
          column = _ref4.column;

      if (column.type !== ColumnTypes.TODO) {
        return next();
      }

      return React.createElement(TodoField, {
        database: database,
        field: field,
        columnKey: column.key,
        recordKey: record.key
      });
    },
    getWidth: function getWidth(columnType, database, next) {
      if ([ColumnTypes.TODO].includes(columnType)) {
        return 140;
      }

      return next();
    },
    convertField: function convertField(source, destination, database, next) {
      if (ColumnTypes.TODO !== destination.column.type) return next();
      var fieldAsText = typeof source === 'string' ? source : database.run('serializeField', source);
      return {
        checked: isTextChecked(fieldAsText)
      };
    },
    serializeField: function serializeField(_ref5, database, next) {
      var column = _ref5.column,
          field = _ref5.field;
      if (ColumnTypes.TODO !== column.type) return next();
      return isFieldChecked(field) ? 'checked' : '';
    }
  }];
}